import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { IColumnDefinition } from '@common/models/column-definition';
import { IResizedColumn, ITable } from '@common/models/table';
import { EntityKey } from '@pma-entity/pma-entity-types';

// ---

export const loadTable = createAction(
  actionLabel('Load Table'),
  props<{ id: string; entityName: string, key: EntityKey | undefined, widgetId?: number  }>()
);
export const loadTableComplete = createAction(
  actionLabel('Load Table Complete'),
  props<{ id: string; table: ITable }>()
);
export const loadTableError = createAction(
  actionLabel('Load Table Error'),
  props<{ id: string; error: Error | HttpErrorResponse | string }>()
);

// ---

export const getAvailableColumns = createAction(
  actionLabel('Get Available Columns'),
  props<{ id: string; entityName: string, widgetId?: number }>()
);
export const getAvailableColumnsComplete = createAction(
  actionLabel('Get Available Columns Complete'),
  props<{ id: string; columns: IColumnDefinition[] }>()
);
export const getAvailableColumnsError = createAction(
  actionLabel('Get Available Columns Error'),
  props<{ id: string; error: Error | HttpErrorResponse | string }>()
);

// ---

export const getAllColumns = createAction(
  actionLabel('Get All Columns'),
  props<{ id: string; entityName: string }>()
);
export const getAllColumnsComplete = createAction(
  actionLabel('Get All Columns Complete'),
  props<{ id: string; allColumns: IColumnDefinition[] }>()
);
export const getAllColumnsError = createAction(
  actionLabel('Get All Columns Error'),
  props<{ id: string; error: Error | HttpErrorResponse | string }>()
);

// ---

export const setSelectedColumns = createAction(
  actionLabel('Set Selected Columns'),
  props<{
    id: string;
    entityName: string;
    selectedColumns: IColumnDefinition[];
    key: EntityKey | undefined;
    widgetId?: number;
  }>()
);
export const setSelectedColumnsComplete = createAction(
  actionLabel('Set Selected Columns Complete'),
  props<{ id: string, 
    entityName: string;
    widgetId?: number; }>()
);
export const setSelectedColumnsError = createAction(
  actionLabel('Set Selected Columns Error'),
  props<{ id: string; error: Error | HttpErrorResponse | string }>()
);

// ---

export const reorderColumns = createAction(
  actionLabel('Reorder Columns'),
  props<{ id: string; entityName: string; orderedColumns: string[], widgetId?: number }>()
);
export const reorderColumnsComplete = createAction(
  actionLabel('Reorder Columns Complete'),
  props<{ id: string }>()
);
export const reorderColumnsError = createAction(
  actionLabel('Reorder Columns Error'),
  props<{ id: string; error: Error | HttpErrorResponse | string }>()
);

// ---

export const resizeColumn = createAction(
  actionLabel('Resize Column'),
  props<{
    id: string;
    entityName: string;
    resizedColumn: IResizedColumn;
    widgetId?: number; 
  }>()
);
export const resizeColumnComplete = createAction(
  actionLabel('Resize Column Complete'),
  props<{ id: string }>()
);
export const resizeColumnError = createAction(
  actionLabel('Resize Column Error'),
  props<{ id: string; error: Error | HttpErrorResponse | string }>()
);

// ---

export const resetColumnsToDefault = createAction(
  actionLabel('Reset Columns To Default'),
  props<{ id: string; entityName: string, key: EntityKey | undefined; widgetId?: number}>()
);
export const resetColumnsToDefaultComplete = createAction(
  actionLabel('Reset Column To Default Complete'),
  props<{ id: string }>()
);
export const resetColumnsToDefaultError = createAction(
  actionLabel('Reset Column To Default Error'),
  props<{ id: string; error: Error | HttpErrorResponse | string }>()
);

// ---

export const clearState = createAction(
  actionLabel('Clear State'),
  props<{ id: string }>()
);

// ---

function actionLabel(label: string): string {
  return '[Table/API] ' + label;
}
